import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { Countdown } from './Countdown';
import { CHECKOUT_LINKS } from '../config/checkout';
export function Pricing() {
  return <section id="pricing" className="py-20 md:py-32 bg-white relative" data-id="element-133">
      <div className="max-w-5xl mx-auto px-4" data-id="element-134">
        {/* Urgency Header */}
        <div className="text-center mb-16" data-id="element-135">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block bg-cream border border-sand rounded-2xl p-6 md:p-8 shadow-sm mb-8" data-id="element-136">
            <h3 className="text-sm font-bold tracking-widest text-ember uppercase mb-6 flex items-center justify-center gap-2" data-id="element-137">
              <span className="text-lg" data-id="element-138">⏰</span> PRECIO DE LANZAMIENTO — CIERRA
              EN:
            </h3>
            <Countdown data-id="element-139" />
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="max-w-md mx-auto space-y-4" data-id="element-140">
            <p className="text-charcoal/80 font-medium flex items-center justify-center gap-2" data-id="element-141">
              <span data-id="element-142">⚠️</span> Después sube $8.000 ARS. No vuelve.
            </p>
            <div className="bg-cream rounded-full h-3 w-full overflow-hidden border border-sand/50" data-id="element-143">
              <div className="bg-ember h-full w-[71%] rounded-full" data-id="element-144" />
            </div>
            <p className="text-xs font-bold text-charcoal/60 uppercase tracking-wide" data-id="element-145">
              🔴 71% de los cupos al precio de lanzamiento ya tomados
            </p>
          </motion.div>
        </div>

        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-12" data-id="element-146">
          ELEGÍ TU AIRPACK
        </h2>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-20 items-center" data-id="element-147">
          {/* Esencial */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-sand rounded-2xl p-8 shadow-sm flex flex-col h-full" data-id="element-148">
            <h3 className="text-xl font-serif font-bold text-charcoal mb-2 flex items-center gap-2" data-id="element-149">
              <span data-id="element-150">📘</span> AIRPACK ESENCIAL
            </h3>
            <p className="text-sm font-medium text-charcoal/60 mb-6" data-id="element-151">
              6 Tomos + 4 Bonos
            </p>

            <div className="mb-8" data-id="element-152">
              <span className="line-through text-charcoal/40 text-lg font-medium block mb-1" data-id="element-153">
                $49.000
              </span>
              <div className="flex items-baseline gap-1" data-id="element-154">
                <span className="text-4xl font-serif font-bold text-charcoal" data-id="element-155">
                  $19.900
                </span>
                <span className="text-sm font-bold text-charcoal/60" data-id="element-156">ARS</span>
              </div>
            </div>

            <a href={CHECKOUT_LINKS.esencial} target="_blank" rel="noopener noreferrer" className="w-full py-4 rounded-xl border-2 border-charcoal text-charcoal font-bold hover:bg-charcoal hover:text-white transition-colors mt-auto text-center block" data-id="element-157">
              → QUIERO MI AIRPACK ESENCIAL
            </a>
          </motion.div>

          {/* Completo */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-cream border-2 border-ember rounded-2xl p-8 shadow-xl relative flex flex-col h-full md:scale-105 z-10" data-id="element-158">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-ember text-white text-xs font-bold px-4 py-1.5 rounded-full tracking-widest uppercase shadow-sm whitespace-nowrap" data-id="element-159">
              ⭐ MÁS ELEGIDO
            </div>

            <h3 className="text-2xl font-serif font-bold text-charcoal mb-2 flex items-center gap-2" data-id="element-160">
              <span data-id="element-161">🏆</span> AIRPACK COMPLETO
            </h3>
            <p className="text-sm font-medium text-charcoal/80 mb-6 leading-relaxed" data-id="element-162">
              6 Tomos + 4 Bonos +{' '}
              <strong className="text-ember" data-id="element-163">
                Pack Herramientas Avanzadas
              </strong>
            </p>

            <div className="mb-8" data-id="element-164">
              <span className="line-through text-charcoal/40 text-lg font-medium block mb-1" data-id="element-165">
                $77.900
              </span>
              <div className="flex items-baseline gap-1" data-id="element-166">
                <span className="text-5xl font-serif font-bold text-ember" data-id="element-167">
                  $29.900
                </span>
                <span className="text-sm font-bold text-ember/80" data-id="element-168">ARS</span>
              </div>
            </div>

            <a href={CHECKOUT_LINKS.completo} target="_blank" rel="noopener noreferrer" className="w-full py-4 rounded-xl bg-ember hover:bg-ember-dark text-white font-bold transition-all hover:scale-[1.02] active:scale-[0.98] shadow-md mt-auto text-lg text-center block" data-id="element-169">
              → QUIERO EL AIRPACK COMPLETO
            </a>
          </motion.div>
        </div>

        {/* Comparison Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto" data-id="element-170">
          <h3 className="text-2xl font-serif font-bold text-center mb-8" data-id="element-171">
            ¿Qué agrega el Pack Avanzado?
          </h3>

          <div className="bg-white rounded-2xl border border-sand shadow-sm overflow-hidden" data-id="element-172">
            <div className="overflow-x-auto scrollbar-hide" data-id="element-173">
              <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-174">
                <thead data-id="element-175">
                  <tr className="bg-cream border-b border-sand" data-id="element-176">
                    <th className="p-4 md:p-6 font-bold text-charcoal/60 text-sm uppercase tracking-wider w-1/3" data-id="element-177">
                      Situación
                    </th>
                    <th className="p-4 md:p-6 font-bold text-charcoal/60 text-sm uppercase tracking-wider w-1/3" data-id="element-178">
                      <div className="flex items-center gap-2" data-id="element-179">
                        <X size={16} className="text-red-500" data-id="element-180" /> Sin Pack
                      </div>
                    </th>
                    <th className="p-4 md:p-6 font-bold text-ember text-sm uppercase tracking-wider w-1/3 bg-ember/5" data-id="element-181">
                      <div className="flex items-center gap-2" data-id="element-182">
                        <Check size={16} className="text-ember" data-id="element-183" /> Con Pack
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-sand" data-id="element-184">
                  {[['No sabés qué cocinar esta semana', 'Delivery de nuevo', '365 días de menú resueltos'], ['Una receta salió mal', 'La repetís igual', 'Causa + solución en segundos'], ['Querés hacer repostería', 'Buscás en Google', '200 recetas de panes y tortas'], ['El gas y la luz suben', 'Seguís gastando igual', '40% menos de gasto'], ['Querés resolver la semana entera', 'Cocinás todos los días', 'Semana lista en 90 minutos']].map((row, i) => <tr key={i} className="hover:bg-cream/30 transition-colors" data-id="element-185">
                      <td className="p-4 md:p-6 text-sm md:text-base font-medium text-charcoal/80" data-id="element-186">
                        {row[0]}
                      </td>
                      <td className="p-4 md:p-6 text-sm md:text-base text-charcoal/60" data-id="element-187">
                        {row[1]}
                      </td>
                      <td className="p-4 md:p-6 text-sm md:text-base font-bold text-ember bg-ember/5" data-id="element-188">
                        {row[2]}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
          <p className="text-center text-xs text-charcoal/40 mt-4 md:hidden italic" data-id="element-189">
            ← Deslizá para ver la tabla completa →
          </p>
        </motion.div>
      </div>
    </section>;
}